<template>
  <Header header__white="header__white" />
  <Breadcrumb title="faq.sideNav" subtitle="faq.title" />
  <FAQQ/>
  <Footer footerPadding="true" />
</template>

<script>
import Header from '../components/Home/Header.vue';
import Breadcrumb from '../components/common/Breadcrumb.vue';
import FAQQ from '../components/common/faqq.vue';
import Footer from '../components/Home/Footer.vue';

export default {
  name:'AboutPage',
  components:{
    Header,
    Breadcrumb,
    FAQQ,
    // BrandArea,
    // Testimonial,
    // WhyArea,
    // CounterArea,
    // BannerArea,
    Footer,
  }
}
</script>
